import React from "react"
import Label from "@kit/design/label"
import Input from "@kit/design/input"
import { ColorInput } from "@kit/design/color-picker"
import PixelSlider from "@kit/design/pixel-slider"
import { useBlocks } from "app/regions/hooks/use-blocks"
import { Padding } from "app/regions/blocks/section/utils/padding"
import { Margin } from "app/regions/blocks/section/utils/margin"
import { ColumnRatio } from "../../components/column-ratio"
import { BlocksImageUploader } from "app/regions/blocks/shared/blocks-image-uploader"
import { Expander } from "app/regions/blocks/shared/expander"
import { BackgroundColor } from "../../components/background-color"
import { BorderSettings } from "../../components/border-settings"
import { GAP_IF_UNDEFINED } from "./constants"
import { useSavedColors } from "hooks/use-saved-colors"

export function ImageLeftCTARightSettings({ block_id }) {
  const { properties, update } = useBlocks(block_id)
  const savedColors = useSavedColors()

  return (
    <>
      <div className="mb-4">
        <BlocksImageUploader
          className="h-40"
          label="Image"
          name="image"
          image={properties.image}
          alt={properties.alt}
          update={file =>
            update({
              image: file.image || properties.image,
              alt: file.alt
            })
          }
          remove={() => update({ image: "", alt: "" })}
        />
      </div>

      <div className="mb-4">
        <Label htmlFor="imageUrl">Image URL</Label>
        <Input
          className="text-gray-700 mb-1 w-full"
          placeholder="https://example.com"
          name="imageUrl"
          onChange={e => update({ imageUrl: e.target.value })}
          value={properties.imageUrl || ""}
        />
      </div>

      <div className="mb-4">
        <ColumnRatio properties={properties} update={update} />
      </div>

      <Expander label="Spacing">
        <div className="mb-4">
          <PixelSlider
            label="Gap"
            name="gap"
            value={
              properties.gap === undefined ? GAP_IF_UNDEFINED : properties.gap
            }
            onChange={e => update({ gap: e })}
            min={0}
            max={60}
          />
        </div>

        <div className="mb-4">
          <Padding properties={properties} update={update} />
        </div>

        <div className="mb-4">
          <Margin properties={properties} update={update} />
        </div>
      </Expander>

      <Expander label="Colors">
        <BackgroundColor properties={properties} update={update} />

        <div>
          <Label htmlFor="headingColor">Heading</Label>
          <ColorInput
            id="headingColor"
            name="headingColor"
            onChange={color => update({ headingColor: color.hex })}
            value={properties.headingColor}
            savedColors={savedColors}
          />
        </div>

        <div>
          <Label htmlFor="textColor">Text</Label>
          <ColorInput
            id="textColor"
            name="textColor"
            onChange={color => update({ textColor: color.hex })}
            value={properties.textColor}
            savedColors={savedColors}
          />
        </div>
      </Expander>

      <BorderSettings properties={properties} update={update} />
    </>
  )
}
